import Select from "../../../../../UI/Form/Select/Select";
import { getJoinedName } from "../../../../../charts/TableView/functions/tableMapper";
import Checkbox from "../../../../../UI/Form/Checkbox/Checkbox";
import { columnFormats } from "../../../../../utils/constants/constants";
import { getNestedXlsxFormat } from "../helper";

export default function HideNullableColumns({
  setChartState,
  chart,
  column,
  isFormula,
  subIndex,
  limitedSupport,
}) {
  const headers = chart.staticGroupingKeys?.length
    ? chart.staticGroupingKeys
    : null;

  const isHiddenOnEmpty = (chart.hiddenNullableColumns ?? []).includes(column);

  function getColumnName() {
    return headers ? getJoinedName(headers[subIndex]) + column : column;
  }

  function getIsHidden() {
    return (chart.hiddenColumns ?? []).includes(getColumnName());
  }

  const isHidden = getIsHidden();

  const normalizedNullValues = chart.normalizedNullValues ?? [];
  const isNormalized = normalizedNullValues.includes(column);

  const replacedNegatives = chart.replacedNegatives ?? [];
  const isNegativesReplaced = replacedNegatives.includes(column);

  function removeFromHidden(iterable) {
    return iterable.filter((item) => item !== getColumnName());
  }

  function toggleColumnVisibility(key, isHidden) {
    const iterable = chart[key] ?? [];

    setChartState({
      ...chart,
      [key]: isHidden
        ? removeFromHidden(iterable)
        : [...iterable, getColumnName()],
    });
  }

  function normalizeColumn() {
    setChartState({
      ...chart,
      normalizedNullValues: isNormalized
        ? normalizedNullValues.filter((item) => item !== column)
        : [...normalizedNullValues, column],
    });
  }

  function replaceNegatives() {
    setChartState({
      ...chart,
      replacedNegatives: isNegativesReplaced
        ? replacedNegatives.filter((item) => item !== column)
        : [...replacedNegatives, column],
    });
  }

  const exportFormatOverrides = chart.exportFormatOverrides ?? {};
  function overrideExportFormat(option) {
    setChartState({
      ...chart,
      exportFormatOverrides: {
        ...exportFormatOverrides,
        [column]: option.xlsx ?? null,
      },
    });
  }

  return (
    <div>
      <br />
      <Select
        options={columnFormats.map((item) => ({
          ...item,
          options: item.options.filter(
            (o) => o.value !== "WEEK_RANGE_TO_US_DATE_SHORT"
          ),
        }))}
        value={getNestedXlsxFormat(exportFormatOverrides[column])}
        onChange={overrideExportFormat}
        label="Export Format Override"
      />

      {isFormula ? (
        <>
          <br />
          <Checkbox
            label="Replace null values with 0"
            checked={isNormalized}
            onChange={normalizeColumn}
            disabled={limitedSupport}
          />
        </>
      ) : null}
      <br />
      <Checkbox
        label="Hide column if column data is empty"
        checked={isHiddenOnEmpty}
        onChange={() =>
          toggleColumnVisibility("hiddenNullableColumns", isHiddenOnEmpty)
        }
        disabled={limitedSupport}
      />
      <br />
      <Checkbox
        label="Hide column in table"
        checked={isHidden}
        onChange={() => toggleColumnVisibility("hiddenColumns", isHidden)}
        disabled={limitedSupport}
      />
      <br />
      {!isFormula ? (
        <Checkbox
          label="Replace negatives with 0"
          checked={isNegativesReplaced}
          onChange={replaceNegatives}
          disabled={limitedSupport}
        />
      ) : null}
    </div>
  );
}
